import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const GymIcon40 = (props: SvgProps) => <Svg
  width='40'
  height='41'
  viewBox='0 0 40 41'
  fill='none'
  {...props}
>
  <Path
    d='M13.75 9.25H10C9.30964 9.25 8.75 9.80964 8.75 10.5V30.5C8.75 31.1904 9.30964 31.75 10 31.75H13.75C14.4404 31.75 15 31.1904 15 30.5V10.5C15 9.80964 14.4404 9.25 13.75 9.25Z'
    stroke='#3379BD'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
  <Path
    d='M30 9.25H26.25C25.5596 9.25 25 9.80964 25 10.5V30.5C25 31.1904 25.5596 31.75 26.25 31.75H30C30.6904 31.75 31.25 31.1904 31.25 30.5V10.5C31.25 9.80964 30.6904 9.25 30 9.25Z'
    stroke='#3379BD'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
  <Path
    d='M31.25 13H35C35.3315 13 35.6495 13.1317 35.8839 13.3661C36.1183 13.6005 36.25 13.9185 36.25 14.25V26.75C36.25 27.0815 36.1183 27.3995 35.8839 27.6339C35.6495 27.8683 35.3315 28 35 28H31.25'
    stroke='#3379BD'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
  <Path
    d='M8.75 28H5C4.66848 28 4.35054 27.8683 4.11612 27.6339C3.8817 27.3995 3.75 27.0815 3.75 26.75V14.25C3.75 13.9185 3.8817 13.6005 4.11612 13.3661C4.35054 13.1317 4.66848 13 5 13H8.75'
    stroke='#3379BD'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
  <Path
    d='M15 20.5H25'
    stroke='#3379BD'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
  <Path
    d='M36.25 20.5H38.75'
    stroke='#3379BD'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round' />
  <Path
    d='M1.25 20.5H3.75'
    stroke='#3379BD'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
</Svg>;

export default GymIcon40;
